// extracted by mini-css-extract-plugin
export default {"icon":"Style_icon__0duNr","stat":"Style_stat__UKj+E","label":"Style_label__xvxxC","value":"Style_value__pgRmu","count":"Style_count__JcM3T"};